import React, { useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid2 from "@mui/material/Grid2";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import { CircularProgress, Box } from "@mui/material";
import { sendPasswordResetEmail } from "firebase/auth";

import { validateEmail } from "utils/helperFunctions";
import { auth } from "config/firebase";

interface ResetPasswordProps {
  setSignin: () => void;
  setSignup: () => void;
}

export default function ResetPassword(props: ResetPasswordProps) {
  const [errMsg, setErrMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [values, setValues] = useState({
    email: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const sendResetEmail = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setSuccessMsg("");

    if (!validateEmail(values.email)) {
      setErrMsg("Please enter a valid email");
      setIsLoading(false);
    } else {
      setErrMsg("");
    }
    sendPasswordResetEmail(auth, values.email, {
        url: "https://localpoker.info/",
      })
      .then(() => {
        setSuccessMsg(
          "We have sent an email with instruction on how to reset your password.",
        );
      })
      .catch((err: any) => {
        console.log("err reseting password", err);
        setErrMsg(err.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <Avatar 
        sx={{ 
          mt: 3, 
          mb: 2,
          backgroundColor: 'primary.main' 
        }}
      >
        <LockOutlinedIcon />
      </Avatar>
      <Typography component="h1" variant="h5" sx={{ mb: 2 }}>
        Reset Password
      </Typography>
      <Box component="form" noValidate sx={{ width: '100%' }}>
        <TextField
          value={values.email}
          onChange={handleInputChange}
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="email"
          label="Email Address"
          name="email"
          autoComplete="email"
          autoFocus
        />
        {!isLoading ? (
          <Button
            onClick={sendResetEmail}
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 3, mb: 2 }}
          >
            Reset Password
          </Button>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 3, mb: 2 }}>
            <Typography variant="body2" color="error" sx={{ mb: 1 }}>
              This may take a moment...
            </Typography>
            <CircularProgress />
          </Box>
        )}
        {(errMsg || successMsg) && (
          <Typography 
            variant="body2" 
            color={errMsg ? "error" : "success"}
            sx={{ mt: 2, textAlign: 'center' }}
          >
            {errMsg || successMsg}
          </Typography>
        )}
        <Grid2 container spacing={2} sx={{ mt: 2, justifyContent: 'center' }}>
          <Grid2>
            <Link href="#" onClick={props.setSignin} variant="body2">
              Login
            </Link>
          </Grid2>
          <Grid2>
            <Link href="#" onClick={props.setSignup} variant="body2">
              Sign Up
            </Link>
          </Grid2>
        </Grid2>
      </Box>
    </Box>
  );
}
